import React from 'react';
import { Modal, Button } from 'react-bootstrap';

function Rgpd({ showModal, setShowModal, setRgpdChecked }) {
  const handleAccept = () => {
    setShowModal(false);
    setRgpdChecked(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setRgpdChecked(false);
  };

  return (
    <Modal show={showModal} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirmation des conditions d'inscription</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Veuillez lire et accepter les conditions avant de continuer.</p>
        <ol>
          <li><strong>Finalité du traitement des données</strong>: Vos données seront collectées dans le but de gérer votre équipe de football et d'accéder aux fonctionnalités de notre plateforme.</li>
          <li><strong>Utilisation des données</strong>: Nous utiliserons vos données personnelles pour vous permettre de créer et de gérer votre équipe, pour vous informer des matchs à venir, des résultats et des actualités liées à votre équipe, et pour améliorer nos services.</li>
          <li><strong>Protection des données</strong>: Nous mettons en œuvre des mesures de sécurité pour protéger vos données personnelles contre tout accès non autorisé ou toute utilisation abusive.</li>
          <li><strong>Durée de conservation des données</strong>: Vos données seront conservées aussi longtemps que nécessaire pour gérer votre équipe et fournir nos services, sauf indication contraire de votre part.</li>
          <li><strong>Droits des utilisateurs</strong>: Vous avez le droit d'accéder à vos données personnelles, de les rectifier, de les supprimer et de vous opposer à leur traitement. Vous pouvez exercer ces droits en nous contactant via les coordonnées fournies sur notre site.</li>
          <li><strong>Consentement</strong>: En cliquant sur accepter, vous confirmez avoir lu et compris ces conditions et consentez au traitement de vos données personnelles conformément à celles-ci pour gérer votre équipe de football.</li>
        </ol>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>Fermer</Button>
        <Button variant="primary" onClick={handleAccept} style={{backgroundColor:"#00E676", borderColor:'#00E676'}}>Accepter</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default Rgpd;
